import {ORGANIATION} from '../constants/actionTypes';
import initial from './initialState';

export default function (state = initial.organizationState, action) {
  switch (action.type) {
    case ORGANIATION.GET_LIST_SUCCESS:
      return {...state, items: action.data.items || [], count: action.data.count || 0};
    case ORGANIATION.RELOAD:
      return {...state, reload: !state.reload};
    default:
      return state;
  }
}
